import { render, staticRenderFns } from "./Paginator.vue?vue&type=template&id=59656db6&scoped=true&"
import script from "./Paginator.vue?vue&type=script&lang=js&"
export * from "./Paginator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59656db6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/projects/releases/338/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('59656db6')) {
      api.createRecord('59656db6', component.options)
    } else {
      api.reload('59656db6', component.options)
    }
    module.hot.accept("./Paginator.vue?vue&type=template&id=59656db6&scoped=true&", function () {
      api.rerender('59656db6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Paginator.vue"
export default component.exports